import { JhiDateUtils } from 'ng-jhipster';
import { BaseEntity } from '../models';

export class TimeTableFixed implements BaseEntity {

    constructor(public id?: number,
                public dayOfWeek?: number,
                public startHour?: any,
                public endHour?: any,
                public queueId?: number) {
    }

    public convertToSimpleTypes(dateUtils: JhiDateUtils) {
        this.startHour = dateUtils.toDate(this.startHour);
        this.endHour = dateUtils.toDate(this.endHour);
    }

    public convertFromServerTypes(dateUtils: JhiDateUtils) {
        this.startHour = dateUtils.convertDateTimeFromServer(this.startHour);
        this.endHour = dateUtils.convertDateTimeFromServer(this.endHour);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/models/time-table-fixed.model.ts